module.exports = __webpack_public_path__ + "img/slack-logo.2fa09cc1.svg";